/**
 * Visitor Map — shared component rendered by both route wrappers:
 *   - $mapSlug.tsx (subdomain/custom_domain mode)
 *   - $orgSlug.$mapSlug.tsx (dev/admin mode + legacy URLs)
 *
 * Provides SheetOverlayContext. All tab pages render inside VisitorLayout.
 */
import { SheetOverlayProvider } from "../../contexts/SheetOverlayContext";
import { VisitorLayout } from "./VisitorLayout";
import type { VisitorSearchParams } from "../../lib/visitor-search";

interface VisitorMapBySlugProps {
  orgSlug: string;
  mapSlug: string;
  search: VisitorSearchParams;
}

export function VisitorMapBySlug({ orgSlug, mapSlug, search }: VisitorMapBySlugProps) {
  return (
    <SheetOverlayProvider>
      <VisitorLayout orgSlug={orgSlug} mapSlug={mapSlug} search={search} />
    </SheetOverlayProvider>
  );
}
